import { Injectable } from '@angular/core';
import { Observable ,  BehaviorSubject } from 'rxjs';

import { uuid } from '../../../utils/uuid';
import { FlashMessage } from '../models/flash-message';

@Injectable()
export class FlashService {
  delay = 6000;
  flashes: FlashMessage[] = [];
  flashSubject = new BehaviorSubject(this.flashes);

  get() {
    return this.flashSubject.asObservable();
  }

  add(message, delay = null, type = 'info') {
    const id = uuid();

    delay = delay || this.delay;

    this.flashes.push({
      id: id,
      type: type,
      message: message
    });

    this.flashSubject.next(this.flashes);

    setTimeout(() => {
      this.close(id);
    }, delay);
  }

  close(id) {
    this.flashes = this.flashes.filter((flash) => flash.id !== id );

    this.flashSubject.next(this.flashes);
  }

  success(message, delay = null) {
    this.add(message, delay, 'success');
  }

  error(message, delay = null) {
    this.add(message, delay, 'error');
  }

  important(message, delay = null) {
    this.add(message, delay, 'important');
  }

  info(message, delay = null) {
      this.add(message, delay, 'info');
  }

  warning(message, delay = null) {
    this.add(message, delay, 'warning');
  }
}
